import React from "react";
import "../tracker/tracker.css";
import axios from "axios";
import jQuery from "jquery";
import Header from "../tracker/common/header";
import Footer from "../tracker/common/footer";

class UsaData extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      apptitle: this.props.apptitle,
      covidData: [],
      covidStatesUsa: []
    };
  }

  componentDidMount = (e) => {
    axios
      .get("https://api.covidtracking.com/v1/states/current.json", this.state)
      .then((res) => {
        if (res.data) {
          //console.log(res.data);
          var Timestamp = res.data.lastUpdateEt;
          var date = new Date(Timestamp);
          var formattedDate =
            date.getDate() +
            "/" +
            (date.getMonth() + 1) +
            "/" +
            date.getFullYear();
          // var dateTime = formattedDate.toDateString();

          var formattedTime =
            date.getHours() + ":" + date.getMinutes() + ":" + date.getSeconds();
          jQuery("#Timestamp").html(formattedDate);
          jQuery("#datestamp").html(formattedTime);
          //console.log(formattedDate);
          var covidstateSort = res.data;
          var covidC = covidstateSort;

          this.setState({ covidData: res.data });
          this.setState({ covidStatesUsa: covidC });
        }
      })
      .catch((error) => {
        console.log(error);
      });

    jQuery("#selectStateIN").change(function () {
      //alert(jQuery("option:selected", this).attr("data-state"));
      jQuery("#stateName").html(
        jQuery("option:selected", this).attr("data-State")
      );
      jQuery("#TotalConfirmed").html(
        jQuery("option:selected", this).attr("confirmed")
      );
      jQuery("#TotalRecovered").html(
        jQuery("option:selected", this).attr("recovered")
      );
      jQuery("#TotalDeaths").html(
        jQuery("option:selected", this).attr("deaths")
      );
      jQuery("#TotalActive").html(
        jQuery("option:selected", this).attr("active")
      );

      jQuery("#lastUpdated").html(
        jQuery("option:selected", this).attr("lastupdatedtime")
      );
    });
  };

  render() {
    return (
      <section className="tracker-section">
        <Header title={this.props.apptitle} />

        <div className="container bodyContainer">
          <div className="row">
            <div className="col-12">
              <div className="details-column row">
                <div className="col-12">
                  <label> Choose Country</label>
                  <select className="form-control" id="selectState">
                    <option key="null" value="null">
                      - United States of America
                    </option>
                  </select>
                </div>
              </div>
              <div className="details-column row" id="selectStateColumn">
                <div className="col-12">
                  <label> Select State</label>
                  <select className="form-control" id="selectStateIN">
                    <option key="null" value="null">
                      - Select State
                    </option>
                    {this.state.covidStatesUsa.map((covidStates) => (
                      <option
                        key={covidStates.hash}
                        value={covidStates.state}
                        data-state={covidStates.state}
                        active={covidStates.positive}
                        confirmed={covidStates.total}
                        deaths={covidStates.death}
                        lastupdatedtime={covidStates.lastUpdateEt}
                        recovered={covidStates.recovered}
                        totaldeaths={covidStates.death}
                      >
                        - {covidStates.state}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
              <div className="details-column row">
                <div className="col-12">
                  <div className="updated-time-column">
                    <p>
                      <i className="fa fa-bell"></i>&nbsp; Last Updated &nbsp;
                      <span id="lastUpdated"></span> &nbsp;
                    </p>
                  </div>
                </div>
              </div>
              <div className="details-column row">
                <div className="col-12">
                  <p>
                    <strong>State Name: </strong>
                  </p>
                  <h2>
                    <strong>
                      <span id="stateName">****</span>
                    </strong>
                  </h2>
                </div>
              </div>
              <div className="details-column row">
                <div className="col-6">
                  <div className="col-inner red-col">
                    <p>Confirmed:</p>
                    <h2>
                      <strong>
                        <span id="TotalConfirmed">****</span>
                      </strong>
                    </h2>
                  </div>
                </div>
                <div className="col-6">
                  <div className="col-inner blue-col">
                    <p>Active</p>
                    <h2>
                      <strong>
                        <span id="TotalActive">****</span>
                      </strong>
                    </h2>
                  </div>
                </div>
              </div>
              <div className="details-column row">
                <div className="col-6">
                  <div className="col-inner green-col">
                    <p>Recovered</p>
                    <h2>
                      <strong>
                        <span id="TotalRecovered">****</span>
                      </strong>
                    </h2>
                  </div>
                </div>
                <div className="col-6">
                  <div className="col-inner red-col">
                    <p>Deceased</p>
                    <h2>
                      <strong>
                        <span id="TotalDeaths">****</span>
                      </strong>
                    </h2>
                  </div>
                </div>
              </div>
              <br />
              <br />
              <div className="row">
                <Footer />
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }
}

export default UsaData;
